<template>
  <div class="container">
    <div class="mt-11 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/4 mx-auto text-center">
        <img src="@/assets/images/pages/success.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">
        <h1 class="sm:mx-0 mt-5 mb-10 text-5xl d-theme-heading-color">¡Has creado tu contenedor!</h1>
        <h4 class="sm:mx-0 mx-2 sm:mb-10 font-w-400">
          El contenedor se ha configurado correctamente.
        </h4>
        <div class="vx-row mb-4">
          <vs-button size="large" to="/containers" class="mx-auto" type="border">Mis contenedores</vs-button>
        </div>
        <div class="vx-row">
          <vs-button 
            size="large" 
            :to="{ path: '/containers', query: { autoOpen: autoOpen } }" 
            class="mx-auto shadow-md" 
            type="filled" 
            color="primary"
            icon-pack="feather"
            icon="icon-upload"
          >
            Subir documentos
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SuccessContainer",
  computed: {
    autoOpen() {
      return this.$route.query.autoOpen
    }
  }
}
</script>

<style scoped>
.mt-11{
  margin-top: 6.5em!important;
}
</style>
